/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_TagInputs */

const en_gc_search_guides_gridcraft_online_tag = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online editor`)
};

const zh_gc_search_guides_gridcraft_online_tag = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线编辑器`)
};

/**
* | output |
* | --- |
* | "Online editor" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_tag = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_tag(inputs)
	return zh_gc_search_guides_gridcraft_online_tag(inputs)
});
export { gc_search_guides_gridcraft_online_tag as "gc.search_guides.gridcraft_online.tag" }